module.exports = __webpack_public_path__ + "static/media/google-plus-original.70f990e7.svg";